/**
 * Column configuration for Catalog Management tables
 */

// Page title
export const PAGE_TITLE = 'Data Review';

// Toggle label
export const MISSING_MAPPING_TOGGLE_LABEL = 'Missing Mapping';

// Table column headers for different views
export const CATALOG_TABLE_COLUMNS = ['#', 'Product', 'Category', 'Attributes'];
export const IMPORTED_TABLE_COLUMNS = ['Product', 'Category', 'Update', 'New'];
export const IGNORED_TABLE_COLUMNS = ['#', 'Product', 'Category', 'Moved from', 'Comment'];
export const PROCESSED_TABLE_COLUMNS = ['#', 'Product', 'Category', 'New Product'];
export const MISSING_MAPPING_COLUMNS = [
  '#',
  'Product',
  'Category',
  'Unmapped Attribute',
  'Unmapped Attribute Value',
];

// SKU Matched column headers for unified table
export const SKU_MATCHED_CATALOG_COLUMNS = ['', '#', 'Product', 'Category', 'Attributes'];
export const SKU_MATCHED_IMPORTED_COLUMNS = ['Product', 'Category', 'Update', 'New', '', ''];
